export default __webpack_public_path__ + "static/media/previous_section_hover.b1ea975a.svg";